class RelateProductSlide extends HTMLElement {
  constructor() {
    super();
    this.Slide = this.querySelector('.js-related-product-slide');
    this.swiperRelateProductSlide = new Swiper(this.Slide, {
      loop: true,
      navigation: {
        nextEl: ".related-products__button-next",
        prevEl: ".related-products__button-prev",
      },
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 12,
      breakpoints: {
        990: {
          slidesPerView: 4,
          spaceBetween: 30
        }
      }
    });
  }
}
customElements.define("related-product-slide", RelateProductSlide);